<h2 mat-dialog-title>{{ data.title }}</h2>
<mat-dialog-content class="mat-typography">
  <p>{{ data.desc }}</p>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button mat-dialog-close>{{ data.cancelButtonText }}</button>
  <button mat-button color="primary" [mat-dialog-close]="true">{{ data.submitButtonText }}</button>
</mat-dialog-actions>
